(function($){
	$(document).ready(()=>{
		function closeFilterHandler(e) {
			e.preventDefault();
			$('body').removeClass('catalog-filters-open');
			return false;
		}

		$(document).on('click', '#set_filter', closeFilterHandler);
	});
})(jQuery);
